import * as Yup from 'yup';
import { FormErrorMessages } from 'utils/formValidation';

export const addProjectEventSchema = () => {
    return Yup.object().shape({
        label: Yup.string().required(FormErrorMessages.required),
        communication_type: Yup.string().required(FormErrorMessages.required),
        address: Yup.object({
            address: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            address_add: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            city: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional(),
            zipcode: Yup.string()
                .matches(/^\d{5}$/, FormErrorMessages.zipcode_invalid)
                .optional(),
            country: Yup.string().min(3, FormErrorMessages.min_characters).max(200, FormErrorMessages.max_characters).optional()
        }).optional(),
        started_at: Yup.date().required(FormErrorMessages.required),
        ended_at: Yup.date()
            .transform((value, originalValue) => (originalValue === '' || originalValue == null ? null : value))
            .nullable()
            .min(Yup.ref('started_at'), FormErrorMessages.end_before_start)
    });
};
